<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div fxLayout="column" fxFlex>
    <div class="report-selector" [ngClass]="{ 'report-selected': (selectedReport$ | async) }"
         fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 0 auto">
        <mat-form-field *ngIf="visibleDefinitions">

            <mat-select [ngModel]="selectedReportDefinition$ | async"
                        (ngModelChange)="setSelectedReport($event)"
                        placeholder="Choose a Report:"
                        [compareWith]="reportCompareFn">

                <mat-option [value]="undefined">-- Select --</mat-option>
                <mat-option *ngFor="let report of visibleDefinitions" [value]="report">{{report.displayName}}</mat-option>

            </mat-select>

        </mat-form-field>
        <ng-container *ngIf="selectedReportDefinition$ | async; let definition">
            <ng-container *ngIf="definition.subType !== 'csv'">
                <dash-gis-report-controls [definition]="definition"
                                    [keys]="objectKey"
                                    [digitizeKey]="digitizeKey$ | async"></dash-gis-report-controls>
            </ng-container>
        </ng-container>
    </div>
    <ng-container *ngIf="selectedReport$ | async; let selectedReport">
        <ng-container *ngTemplateOutlet="reportType === 'feature' ? featureReport : dataReport; context: {$implicit: selectedReport}"></ng-container>
    </ng-container>
</div>

<ng-template #featureReport let-selectedReport>
    <dash-gis-feature-report [showControls]="false"
                       [launchOptions]="selectedReport$ | async"
                       [uid]="createUid(uid, selectedReport?.definition.name)"
                       (recordCount)="setRecordCount($event)"
                       (clearReports)="clearReports()" fxFlex
                       fxLayout="column"></dash-gis-feature-report>
</ng-template>

<ng-template #dataReport let-selectedReport>
    <dash-gis-data-report [showControls]="false"
                    [launchOptions]="selectedReport$ | async"
                    [uid]="createUid(uid, selectedReport?.definition._name)"
                    (recordCount)="setRecordCount($event)"
                    (clearReports)="clearReports()" fxFlex
                    fxLayout="column"></dash-gis-data-report>
</ng-template>
